import {
  getMsgById,
  getMyMsgCenten,
  getUnreadMsgCount,
  setReadState
} from '@/server/message'

export const NOTIFICATION_TYPES = Object.freeze([
  { id: 7, label: '公告' },
  { id: 2, label: '交易通知' },
  { id: 6, label: '文章' },
  { id: 1, label: '系统通知' }
])

function ensureSuccess(result, fallback) {
  if (!result) throw new Error(`${fallback}接口未返回数据`)
  if (result.success === false) throw new Error(result.message || fallback)
  return result.data
}

function numberValue(value, fallback = 0) {
  const number = Number(value)
  return Number.isFinite(number) ? number : fallback
}

function decodeEntities(value) {
  if (typeof document === 'undefined') return value
  const element = document.createElement('textarea')
  element.innerHTML = value
  return element.value
}

export function plainNotificationContent(value, limit = 90) {
  let decoded = String(value || '')
  for (let index = 0; index < 3; index += 1) {
    const nextValue = decodeEntities(decoded)
    if (nextValue === decoded) break
    decoded = nextValue
  }
  const text = decoded
    .replace(/<script[\s\S]*?<\/script>/gi, ' ')
    .replace(/<style[\s\S]*?<\/style>/gi, ' ')
    .replace(/<[^>]*>/g, ' ')
    .replace(/&npsp;|&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim()
  return limit > 0 && text.length > limit ? `${text.slice(0, limit)}…` : text
}

export function safeNotificationHtml(value) {
  const decoded = String(value || '')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
  return decoded
    .replace(/<script[\s\S]*?<\/script>/gi, '')
    .replace(/<style[\s\S]*?<\/style>/gi, '')
    .replace(/\son[a-z]+\s*=\s*(["']).*?\1/gi, '')
    .replace(/\son[a-z]+\s*=\s*[^\s>]+/gi, '')
    .replace(/(href|src)\s*=\s*(["'])\s*javascript:[\s\S]*?\2/gi, '$1="#"')
}

export function normalizeNotification(raw = {}, typeHint = 0) {
  const id = raw.id ?? raw.msg_id ?? raw.message_id ?? ''
  const state = numberValue(raw.state, 2)
  return {
    id: String(id),
    type: numberValue(raw.msg_type ?? raw.msgType ?? raw.type, numberValue(typeHint)),
    title: String(raw.title || '通知'),
    content: String(raw.content || ''),
    preview: plainNotificationContent(raw.content || ''),
    sendTime: String(raw.send_time || raw.sendTime || raw.create_time || ''),
    state,
    unread: state === 1,
    raw
  }
}

export async function loadNotificationPage(msgType, pageNum = 1, pageSize = 10) {
  const data = ensureSuccess(
    await getMyMsgCenten(msgType, pageNum, pageSize, 10),
    '通知列表读取失败'
  ) || {}
  const source = Array.isArray(data) ? data : (Array.isArray(data.list) ? data.list : [])
  const total = Array.isArray(data)
    ? data.length
    : numberValue(data.totalRow ?? data.total ?? data.count, source.length)
  return {
    rows: source.map(item => normalizeNotification(item, msgType)),
    total,
    page: pageNum,
    pageSize
  }
}

export async function loadNotificationDetail(msgId) {
  const data = ensureSuccess(await getMsgById(msgId), '通知详情读取失败') || {}
  return normalizeNotification(data)
}

export async function loadNotificationUnreadCount(msgType = 0) {
  const data = ensureSuccess(await getUnreadMsgCount(msgType, 10), '未读通知数量读取失败')
  if (data && typeof data === 'object') {
    return numberValue(data.count ?? data.total ?? data.unread_count)
  }
  return numberValue(data)
}

export async function loadNotificationTypeCounts() {
  const entries = await Promise.all(
    NOTIFICATION_TYPES.map(async type => [type.id, await loadNotificationUnreadCount(type.id)])
  )
  return entries.reduce((counts, [id, count]) => {
    counts[id] = count
    return counts
  }, {})
}

export async function markAllNotificationsRead() {
  ensureSuccess(await setReadState(), '全部已读操作失败')
  return true
}
